import Card from '@mui/material/Card';

const TableContainer = ({ children }) => {
  return (
    <Card
      variant="containedBordered"
      sx={{
        bgcolor: 'background.paper2Variant',
        '& .MuiTabs-root': { px: 2 },
      }}
    >
      {children}
    </Card>
  );
};

export default TableContainer;
